import { addDays, format, startOfMonth, startOfWeek } from "date-fns"
import type { CalendarView } from "@/js/types/calendar"

/**
 * Calculate the date range FullCalendar shows for a date in the given view.
 * Month view is always a 6-week grid starting on the Sunday of the week containing the 1st.
 */
export const getVisibleDateRange = (view: CalendarView, date: Date): { startDate: string; endDate: string } => {
	const [start, end] = {
		month: () => {
			const start = startOfWeek(startOfMonth(date))
			return [start, addDays(start, 6 * 7 - 1)]
		},
		week: () => {
			const start = startOfWeek(date)
			return [start, addDays(start, 6)]
		},
		day: () => [date, date],
	}[view]()

	return {
		startDate: format(start, "yyyy-MM-dd"),
		endDate: format(end, "yyyy-MM-dd"),
	}
}
